import React from 'react';
import classNames from 'classnames';
import './LeadPopupConfirmationPreview.pcss';
import { ReactComponent as CheckmarkIcon } from 'assets/icons/fancy_checkmark.svg';
import { PreviewIphone } from '../../common/PreviewIphone/PreviewIphone';

type Props = {
  className?: string;
  description?: string;
  title?: string;
  buttonText?: string;
  isMobile?: boolean;
};

export const LeadPopupConfirmationPreview = ({
  className,
  description = '',
  title = '',
  buttonText = '',
  isMobile,
}: Props) => {
  const content = (
    <div className={classNames(className, 'lead-popup-confirmation-preview')}>
      <div className="lead-popup-confirmation-preview__header">
        <div className="lead-popup-confirmation-preview__image">
          <CheckmarkIcon />
        </div>
      </div>

      <div className="lead-popup-confirmation-preview__content">
        <span className="lead-popup-confirmation-preview__title">{title}</span>

        <span className="lead-popup-confirmation-preview__description">
          {description}
        </span>

        {buttonText && (
          <div className="lead-popup-confirmation-preview__cta-button">
            {buttonText}
          </div>
        )}
      </div>
    </div>
  );

  if (isMobile) return <PreviewIphone>{content}</PreviewIphone>;

  return content;
};
